"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _reactRedux = require("react-redux");
var _layouts = _interopRequireDefault(require("../layouts"));
var _admin = require("../../selectors/admin.js");
var _config = require("../../config.js");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _helpers = require("./helpers.js");
var _ImagePicker = _interopRequireDefault(require("./ImagePicker"));
var _navigations = require("../navigations");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _productListQuery = _interopRequireDefault(require("./productListQuery.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var _validate = function validate(values, assignmentData) {
  var errors = {};

  // title
  if (!values.title) {
    errors.title = 'Title is required';
  }

  // at least one language must be selected
  if (values.buildLanguages.length === 0) {
    errors.buildLanguages = 'At least one language is required';
  }

  // check if we removed languages from deploy and they are used in open deployments
  if (assignmentData) {
    var removedLanguages = (0, _difference2["default"])(assignmentData.settings.languages, values.languages);
    var hasOpenDeployments = assignmentData.deploymentList.some(function (item) {
      return item.isOpen;
    });
    if (removedLanguages.length > 0 && hasOpenDeployments) {
      var languages = {
        es: 'Spanish',
        en: 'English'
      };
      errors.languages = "".concat(removedLanguages.map(function (code) {
        return languages[code];
      }).join(', '), " is used in open deployments");
    }
  }
  return errors;
};
var AssignmentModalContents = /*#__PURE__*/function (_React$Component) {
  function AssignmentModalContents() {
    var _this;
    _classCallCheck(this, AssignmentModalContents);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AssignmentModalContents, [].concat(args));
    _defineProperty(_this, "state", {
      productList: [{
        value: '',
        label: '-- Select a Product --',
        disabled: true
      }],
      licenseRequired: _this.props.initialValues ? !!_this.props.initialValues.productId : false
    });
    _defineProperty(_this, "componentDidMount", function () {
      Fortress.hasAccess('licensing.admin') && _this.getProductList();
    });
    _defineProperty(_this, "getInitialValues", function () {
      // populate build languages if they don't exist
      var buildLanguages = _this.props.initialValues.buildLanguages || _this.props.initialValues.languages || ['en'];
      return _objectSpread(_objectSpread({
        title: '',
        subtitle: '',
        languages: ['en'],
        navigation: 'noSidebar',
        navigationSettings: {},
        frameStyleId: 'default',
        frameStyleSettings: {},
        showHeader: true,
        showFooter: true,
        productId: ''
      }, _this.props.initialValues), {}, {
        buildLanguages: buildLanguages
      });
    });
    _defineProperty(_this, "getProductList", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _productListQuery["default"],
              fetchPolicy: 'network-only'
            }).then(function (r) {
              _this.setState({
                productList: [].concat(_toConsumableArray(_this.state.productList), _toConsumableArray(r.data.products.productList.map(function (p) {
                  return {
                    value: p.productId,
                    label: p.label
                  };
                })))
              });
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    return _this;
  }
  _inherits(AssignmentModalContents, _React$Component);
  return _createClass(AssignmentModalContents, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var project = this.props.project;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: this.getInitialValues(),
        onSubmit: this.props.onSubmit,
        validate: function validate(values) {
          return _validate(values, _this2.props.assignmentData);
        },
        render: function render(_ref2) {
          var handleSubmit = _ref2.handleSubmit,
            isSubmitting = _ref2.isSubmitting,
            values = _ref2.values,
            initialValues = _ref2.initialValues;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, project.label && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].project
          }, "For Quest Project \"".concat(project.label, "\"")), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Title",
              tooltip: "This name is shown only to Quest Project Admins and not survey respondents."
            }),
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "subtitle",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Subtitle",
              tooltip: "This description is shown only to Quest Project Admins and not survey respondents."
            })
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, "Languages:"), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].languageBlocks
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "buildLanguages",
            render: function render(_ref3) {
              var field = _ref3.field,
                form = _ref3.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form,
                label: "Ready to build:"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  display: 'grid',
                  gap: '0.5em'
                }
              }, _config.supportedLanguages.map(function (language) {
                return /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
                  key: language.handle,
                  label: language.label,
                  value: field.value.includes(language.handle),
                  onChange: function onChange() {
                    // remove form deploy if removed form build
                    if (field.value.includes(language.handle)) {
                      form.setFieldValue('languages', form.values.languages.filter(function (item) {
                        return item !== language.handle;
                      }));
                    }
                    form.setFieldValue(field.name, (0, _xor2["default"])(field.value, [language.handle]));
                  }
                });
              })));
            }
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "languages",
            render: function render(_ref4) {
              var field = _ref4.field,
                form = _ref4.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form,
                label: "Ready to deploy:"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  display: 'grid',
                  gap: '0.5em'
                }
              }, _config.supportedLanguages.map(function (language) {
                return /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
                  key: language.handle,
                  label: language.label,
                  value: field.value.includes(language.handle),
                  onChange: function onChange() {
                    // include to build if included for deploy
                    if (!form.values.buildLanguages.includes(language.handle)) {
                      form.setFieldValue('buildLanguages', [].concat(_toConsumableArray(form.values.buildLanguages), [language.handle]));
                    }
                    form.setFieldValue(field.name, (0, _xor2["default"])(field.value, [language.handle]));
                  }
                });
              })));
            }
          }))), /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-info",
            style: {
              paddingBottom: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("h3", null, "Navigation"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "navigation",
            component: _ImagePicker["default"],
            options: (0, _navigations.getNavigations)({
              noCurriculum: true,
              restrictionsLevel: _this2.props.restrictionsLevel,
              requiredNavigation: initialValues.navigation
            }),
            height: "98px",
            settingsFieldName: "navigationSettings"
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-info",
            style: {
              paddingBottom: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("h3", null, "Page style"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "frameStyleId",
            component: _ImagePicker["default"],
            options: _layouts["default"],
            showHeader: values.showHeader,
            showFooter: values.showFooter,
            settingsFieldName: "frameStyleSettings"
          })), Fortress.hasAccess('licensing.admin') && _this2.props.restrictionsLevel === 'unlimited' && /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-info",
            style: {
              paddingBottom: 0
            }
          }, /*#__PURE__*/_react["default"].createElement("h3", null, "Licensing"), /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
            label: "License Required to Access this Quest",
            value: _this2.state.licenseRequired,
            onChange: function onChange() {
              if (_this2.state.licenseRequired) {
                values.productId = '';
              } else {
                values.productId = _this2.props.initialValues ? _this2.props.initialValues.productId : '';
              }
              _this2.setState({
                licenseRequired: !_this2.state.licenseRequired
              });
            }
          }), /*#__PURE__*/_react["default"].createElement("br", null), _this2.state.licenseRequired && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "productId",
            component: _cccisdFormik.CccisdSelect,
            options: _this2.state.productList,
            label: "Product"
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].toggleGroup
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            wrapperClassName: "mb-2",
            name: "showHeader",
            component: _cccisdFormik.CccisdToggle,
            label: "Show header"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "showFooter",
            component: _cccisdFormik.CccisdToggle,
            label: "Show footer"
          })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            title: "Submit",
            isLoading: isSubmitting,
            onClick: handleSubmit
          })));
        }
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(AssignmentModalContents, "propTypes", {
  assignmentData: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  closeModal: _propTypes["default"].func,
  project: _propTypes["default"].object,
  restrictionsLevel: _propTypes["default"].string,
  initialValues: _propTypes["default"].object
});
_defineProperty(AssignmentModalContents, "defaultProps", {
  initialValues: {}
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(AssignmentModalContents);